import { render } from "./PaymentModalApiPage.vue?vue&type=template&id=ff346084&lang=true"
import script from "./PaymentModalApiPage.vue?vue&type=script&lang=js"
export * from "./PaymentModalApiPage.vue?vue&type=script&lang=js"

import "./PaymentModalApiPage.vue?vue&type=style&index=0&id=ff346084&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__